import Product from "../../../../../../@types/Product";

const Tops: Product[] = [
    {
        id: 1,
        name: '63″ MadJax X-Series 2 Passenger Top - Black',
        sku: '26-203',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default Tops;